import { Link } from "react-router-dom";
import { Trash2, Minus, Plus, ArrowRight } from "lucide-react";
import { useCart } from "@/lib/cart";
import { formatFCFA, resolveImage } from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Cart() {
  const { items, removeItem, updateQty, subtotal } = useCart();

  return (
    <div className="bg-white text-[var(--dsf-text)] min-h-screen">
      <Header />
      <div className="pt-32 pb-20 px-6 md:px-12 lg:px-20" data-testid="cart-page">
        <div className="max-w-6xl mx-auto">
          <div className="text-[11px] uppercase tracking-[0.32em] text-[var(--dsf-orange)] mb-3">Panier</div>
          <h1 className="font-serif text-5xl md:text-6xl text-[var(--dd-green)] mb-12">Votre sélection</h1>

          {items.length === 0 ? (
            <div className="py-24 text-center" data-testid="cart-empty">
              <p className="text-lg text-[var(--dsf-text-secondary)] mb-6">Votre panier est vide.</p>
              <Link to="/" className="btn-primary inline-flex">Continuer mes achats <ArrowRight size={16} /></Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
              <div className="lg:col-span-8">
                <div className="border-t border-black/5">
                  {items.map((it, idx) => (
                    <div key={idx} className="flex gap-6 py-6 border-b border-black/5" data-testid={`cart-item-${it.product_id}`}>
                      <Link to={`/produit/${it.product_id}`} className="w-28 h-28 shrink-0 product-img-wrap">
                        <img src={resolveImage(it.image)} alt={it.name} className="w-full h-full object-cover" />
                      </Link>
                      <div className="flex-1 flex flex-col">
                        <div className="flex justify-between gap-4">
                          <div>
                            <h3 className="font-serif text-xl text-[var(--dd-green)] font-semibold">{it.name}</h3>
                            {Object.entries(it.options || {}).map(([k, v]) => (
                              <span key={k} className="text-xs text-[var(--dsf-text-muted)] mr-3">{k}: {v}</span>
                            ))}
                          </div>
                          <button onClick={() => removeItem(it.product_id, it.options)} className="text-[var(--dsf-text-muted)] hover:text-[var(--dsf-orange)]" data-testid={`remove-item-${it.product_id}`}>
                            <Trash2 size={16} />
                          </button>
                        </div>
                        <div className="flex justify-between items-end mt-auto">
                          <div className="flex items-center border border-black/5">
                            <button onClick={() => updateQty(it.product_id, it.options, it.quantity - 1)} className="px-3 py-2"><Minus size={12} /></button>
                            <span className="px-4 text-sm font-medium">{it.quantity}</span>
                            <button onClick={() => updateQty(it.product_id, it.options, it.quantity + 1)} className="px-3 py-2"><Plus size={12} /></button>
                          </div>
                          <div className="font-medium">{formatFCFA(it.price * it.quantity)}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <aside className="lg:col-span-4">
                <div className="sticky top-28 card-light p-8" data-testid="cart-summary">
                  <h2 className="font-serif text-2xl text-[var(--dd-green)] mb-6">Récapitulatif</h2>
                  <div className="space-y-3 text-sm border-b border-black/5 pb-4 mb-4">
                    <div className="flex justify-between"><span>Sous-total</span><span className="font-medium">{formatFCFA(subtotal)}</span></div>
                    <div className="flex justify-between"><span>Livraison</span><span className="text-[var(--dsf-text-muted)]">Calculée à l'étape suivante</span></div>
                  </div>
                  <div className="flex justify-between items-baseline mb-6">
                    <span className="font-serif text-lg">Total estimé</span>
                    <span className="font-serif text-2xl font-semibold text-[var(--dd-green)]" data-testid="cart-total">{formatFCFA(subtotal)}</span>
                  </div>
                  <Link to="/checkout" className="btn-primary w-full justify-center" data-testid="checkout-button">
                    Passer au paiement <ArrowRight size={16} />
                  </Link>
                  <Link to="/" className="block text-center text-sm mt-4 text-[var(--dsf-text-secondary)] hover:text-[var(--dsf-orange)]">
                    Continuer mes achats
                  </Link>
                </div>
              </aside>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
